export const environment = {
  production: true,
  authServiceUrl: 'https://ir2.internal.sparbankensyd.se/service',
  irApiUrl: 'https://ir2.internal.sparbankensyd.se/api',
  domain: 'ir2.internal.sparbankensyd.se',
  bvArn: 'arn:aws:lambda:eu-west-1:225460548507:function:bolagsverket-api-prod',
  testMode: false
}